import { render, staticRenderFns } from "./GameSet.vue?vue&type=template&id=b4b73802&scoped=true"
import script from "./GameSet.vue?vue&type=script&lang=js"
export * from "./GameSet.vue?vue&type=script&lang=js"
import style0 from "./GameSet.vue?vue&type=style&index=0&id=b4b73802&prod&scoped=true&lang=css"
import style1 from "./GameSet.vue?vue&type=style&index=1&id=b4b73802&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4b73802",
  null
  
)

export default component.exports